<template>
	<div>
		<div class="o-media o-media--spacing-regular o-media--top c-post u-margin-bottom-regular" v-if="isPreview">
			<div class="o-media__image">
				<router-link :to="'/post/' + slug">
					<img :src="previewImage" :alt="title">
				</router-link>
			</div>
			<div class="o-media__body u-nudge-bottom-tiny">
				<div class="c-post__title">
					<h2 class="c-type-charlie"><router-link :to="'/post/' + slug">{{title}}</router-link></h2>
				</div>
				<div class="c-post__info u-margin-bottom-small">
					<div class="o-media o-media--spacing-micro u-margin-right-small">
						<div class="o-media__image">
							<icon class="c-icon-user" use="user"></icon>
						</div>
						<div class="o-media__body">
							By {{author}}
						</div>
					</div>
					<div class="o-media o-media--spacing-micro">
						<div class="o-media__image">
							<icon class="c-icon-clock" use="clock"></icon>
						</div>
						<div class="o-media__body">
							{{date}}
						</div>
					</div>
				</div>
				<p class="u-margin-bottom-regular" v-html="preview"></p>
				<router-link :to="'/post/' + slug"><app-button>Read more</app-button></router-link>
			</div>
		</div>
		<article v-if="!isPreview">
			<div class="c-post__header u-margin-bottom-reduced">
				<div class="c-post__header-text">
					<h2 class="c-type-alpha">{{title}}</h2>
					<div class="c-post__header-text-info">
						<div class="o-media o-media--spacing-micro u-margin-right-small">
							<div class="o-media__image">
								<icon class="c-icon-user" use="user"></icon>
							</div>
							<div class="o-media__body">
								By {{author}}
							</div>
						</div>
						<div class="o-media o-media--spacing-micro">
							<div class="o-media__image">
								<icon class="c-icon-clock" use="clock"></icon>
							</div>
							<div class="o-media__body">
								{{date}}
							</div>
						</div>		
					</div>
				</div>
				<img :src="fullImage" :alt="title" class="u-full-width">
			</div>
			<p class="u-margin-bottom-regular" v-html="content"></p>
		</article>
	</div>
</template>

<script>
// Import components
import appButton from '@/components/app-button/app-button'
import icon from '@/components/icons/icons'

// Import SVG icons
import clock from './../../assets/img/clock.svg'
import user from './../../assets/img/user.svg'

export default {
	name: 'post',
	props: {
		title: {
			type: String
		},
		author: {
			type: String
		},
		date: {
			type: String
		},
		preview: {
			type: String
		},
		content: {
			type: String
		},
		slug: {
			type: String
		},
		previewImage: {
			type: String
		},
		fullImage: {
			type: String
		}
	},
	components: {
		icon,
		appButton
	},
	data() {
		return {
			clock,
			user
		}
	},
	computed: {
		// Returns true if post should display as preview
		isPreview: function() {
			if(this.preview && this.previewImage) {
				return true
			}
			return false 
		}
	}
}
</script>



// WEBPACK FOOTER //
// post.vue?306f37e6